"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultMortgageRateTableInput = void 0;
exports.defaultMortgageRateTableInput = {
    yearStart: 10,
    yearLength: 30,
    yearStep: 5,
    rateStart: 1,
    rateLength: 5.5,
    rateStep: 0.25
};
